export default __webpack_public_path__ + "static/media/Win_Logo.091b9a12.svg";